import * as React from 'react';

const SvgBeerGlassFoam = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={54} height={54} fill="none" {...props}>
    <path
      d="M10.125 11.524v1.432a31.276 31.276 0 003.49 14.415v0a31.396 31.396 0 013.36 17.31l-.359 3.919a3.273 3.273 0 003.063 3.712H31.34a3.273 3.273 0 003.06-3.71l-.357-3.921a31.437 31.437 0 013.359-17.31v0A30.868 30.868 0 0040.5 17.94M11.423 21.938h28.172"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.094 27a.844.844 0 110 1.688.844.844 0 010-1.688M27.844 33.75a.844.844 0 110 1.688.844.844 0 010-1.688M24.469 42.188a.844.844 0 110 1.687.844.844 0 010-1.688"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M40.5 1.688H11.812a5.063 5.063 0 000 10.124h18.801A6.675 6.675 0 0040.5 15.94v7.686a3.375 3.375 0 106.75 0V8.437a6.75 6.75 0 00-6.75-6.75z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgBeerGlassFoam;
